var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M13.144 5.774A3.38 3.38 0 0 0 8.787.63l-.038.026a.747.747 0 1 0 .87 1.216l.038-.025a1.884 1.884 0 0 1 2.428 2.867L9.46 7.343a1.885 1.885 0 0 1-2.867-2.428l.025-.037a.748.748 0 0 0-1.216-.87l-.026.037a3.38 3.38 0 0 0 5.14 4.355l2.628-2.626ZM.99 5.226a3.38 3.38 0 0 0 4.357 5.144l.038-.026a.747.747 0 1 0-.87-1.216l-.038.025a1.883 1.883 0 0 1-2.427-.2 1.887 1.887 0 0 1 0-2.67l2.624-2.626a1.885 1.885 0 0 1 2.867 2.43l-.025.037a.748.748 0 0 0 1.216.87l.026-.037A3.38 3.38 0 0 0 3.619 2.6L.99 5.226Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.cc6e5b78749d7043cce488e58737e1e8.svg";
export { ForwardRef as ReactComponent };